import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon, DownloadIcon } from 'lucide-react';
export function PricingCTA() {
  return <section id="download" className="py-24 px-4 sm:px-6 lg:px-8" data-id="element-56">
      <div className="max-w-3xl mx-auto" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="bg-pastel-peach rounded-[3rem] p-8 md:p-14 text-center shadow-soft-lg relative overflow-hidden border-4 border-white" data-id="element-58">
          <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-59">
            Get Your Copy Now
          </h2>
          <p className="text-brand-terracotta font-semibold mb-8" data-id="element-60">
            Start creating magical moments today
          </p>

          <div className="mb-8" data-id="element-61">
            <span className="text-6xl md:text-7xl font-bold text-brand-brown-dark tracking-tight" data-id="element-62">
              $6.35
            </span>
            <span className="text-xl text-brand-gray-warm ml-2 font-medium" data-id="element-63">
              USD
            </span>
          </div>

          <ul className="space-y-3 mb-10 text-left max-w-sm mx-auto" data-id="element-64">
            {['50 creative activities', 'Instant PDF download', 'Step-by-step instructions', 'Indoor & outdoor ideas'].map((feature, idx) => <li key={idx} className="flex items-center gap-3 text-brand-brown-dark font-medium" data-id="element-65">
                <CheckIcon className="w-5 h-5 text-brand-sage flex-shrink-0" data-id="element-66" />
                <span data-id="element-67">{feature}</span>
              </li>)}
          </ul>

          <a href="https://www.allopenwellness.com/cart/46862327251075:1" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 md:px-12 py-5 bg-brand-peach hover:bg-brand-peach-hover text-white rounded-full font-bold text-xl shadow-soft hover:shadow-soft-lg transition-all duration-300 transform hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-brand-peach/30 flex items-center justify-center gap-3 mx-auto" aria-label="Buy Now and Instant Download" data-id="element-68">
            <DownloadIcon className="w-6 h-6" data-id="element-69" />
            <span data-id="element-70">Buy Now & Instant Download</span>
          </a>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-brand-gray-warm font-medium" data-id="element-71">
            <LockIcon className="w-4 h-4 text-brand-sage" data-id="element-72" />
            <span data-id="element-73">Secure payment • Instant download</span>
          </div>
        </motion.div>
      </div>
    </section>;
}